import React from "react";
import {LinkButton} from "../LinkButton";
import {Flex, Text} from "@chakra-ui/react";

interface Props {
    setVersionPickerVisible: (visible: "retail" | "BPD" | false) => void;
}

export const Footer = React.memo<Props>(({setVersionPickerVisible}) => {
    return (
        <Flex justifyContent="space-evenly" flexWrap="wrap">
            <LinkButton
                url="https://promo.hungfooktong.com/hftcms/index.php?option=com_content&view=article&id=1287"
                color="primary"
                imageSrc={require("./asset/icon-1.png")}
                text={
                    <Text as="span" fontSize="14px">
                        產品介紹
                    </Text>
                }
            />
            <LinkButton
                url="https://promo.hungfooktong.com/hftcms/index.php?option=com_content&view=article&id=1288"
                color="secondary"
                imageSrc={require("./asset/icon-2.png")}
                text={
                    <React.Fragment>
                        只限企業客戶
                        <br />
                        <Text as="span" fontSize="14px">
                            網上訂購優惠
                        </Text>
                    </React.Fragment>
                }
            />
            <LinkButton
                onClick={() => setVersionPickerVisible("BPD")}
                color="secondary"
                imageSrc={require("./asset/icon-3.png")}
                text={
                    <React.Fragment>
                        只限企業客戶
                        <br />
                        <Text mb="4px" as="span" fontSize="14px">
                            網上付款訂購
                        </Text>
                        訂購熱線：3651 2267
                    </React.Fragment>
                }
            />
            <LinkButton
                onClick={() => setVersionPickerVisible("retail")}
                color="primary"
                imageSrc={require("./asset/icon-4.png")}
                text={
                    <React.Fragment>
                        <Text textAlign="center" mb="4px" as="span" fontSize="14px">
                            已於門市訂購
                            <br />
                            之客戶
                        </Text>
                        (網上禮卡製作服務)
                    </React.Fragment>
                }
            />
            <LinkButton
                url="https://www.hungfooktong.com/gingerbulkpack/orderform.php"
                color="primary"
                imageSrc={require("./asset/icon-4.png")}
                text={
                    <React.Fragment>
                        <Text textAlign="center" mb="4px" as="span" fontSize="14px">
                            已於門市訂購
                            <br />
                            之客戶
                        </Text>
                        (玻璃裝-網上提貨/送貨服務)
                    </React.Fragment>
                }
            />
        </Flex>
    );
});
